module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm1t"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("And hence one master passion in the breast,")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("Like Aaron’s serpent, swallows up the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALEXANDER POPE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd9fc1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Fm01.vue
// module id = 75
// module chunks = 0